import React from "react";

const AltDownloadIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <rect width="40" height="40" rx="10" fill="white"/>
  <path d="M20.5 14.25V23M20.5 23L24.25 19.25M20.5 23L16.75 19.25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M25.5 26.75H15.5" stroke="black" stroke-width="2" stroke-linecap="round"/>
  <path d="M8 20.5C8 14.6075 8 11.6613 9.83 9.83C11.6625 8 14.6075 8 20.5 8C26.3925 8 29.3387 8 31.1687 9.83C33 11.6625 33 14.6075 33 20.5C33 26.3925 33 29.3387 31.1687 31.1687C29.34 33 26.3925 33 20.5 33C14.6075 33 11.6613 33 9.83 31.1687C8 29.34 8 26.3925 8 20.5Z" stroke="black" stroke-width="2"/>
  </svg>
);

export default AltDownloadIcon;
